import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

describe('Template', () => {
  describe('From(new)', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          m_template: {},
          new_templates: [],
          m_part_groups: [],
          return_common_part_groups: []
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index is_edit={false}/>);

      await act(() => promise);
      
      const name = screen.getByRole("textbox", {name: "アンケート名"})  as HTMLInputElement;
      const display_name = screen.getByRole("textbox", {name: "アンケート名（患者画面）"})  as HTMLInputElement;
      const description = screen.getByRole("textbox", {name: "アンケート詳細"})  as HTMLInputElement;
      const radio_1 = screen.getByRole("radio", {name: "新患"})  as HTMLInputElement;
      const radio_2 = screen.getByRole("radio", {name: "再来"})  as HTMLInputElement;

      // Valueの確認
      expect(name.value).toBe("");
      expect(display_name.value).toBe("");
      expect(description.value).toBe("");
      expect(radio_1.value).toBe("20");
      expect(radio_2.value).toBe("30");
      expect(radio_1).toBeChecked();
      expect(radio_2).not.toBeChecked();

      // placeholderの確認
      expect(name.placeholder).toBe("例：男性用アンケート2");
      expect(display_name.placeholder).toBe("例：男性用アンケート");
      expect(description.placeholder).toBe("アンケート詳細を入力してください");
      

      // ボタン類
      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.getByText('作成する')).toBeInTheDocument();
      
    });  
  });

  describe('From(edit)', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          m_template: {id: 2, disable_flg: 0, template_kbn: 30, name: "自社アンケート_1_再来", description: "自社アンケート1_説明", display_web_name: "自社アンケート表示名_1_再来", description_web: null, template_code: 1, m_company_id: 1, share_range_kbn: 0},
          new_templates: [],
          m_part_groups: [],
          return_common_part_groups: []
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index is_edit={true}/>);

      await act(() => promise);
      
      const name = screen.getByRole("textbox", {name: "アンケート名"})  as HTMLInputElement; 
      const display_name = screen.getByRole("textbox", {name: "アンケート名（患者画面）"})  as HTMLInputElement;
      const description = screen.getByRole("textbox", {name: "アンケート詳細"})  as HTMLInputElement;

      // Valueの確認
      expect(name.value).toBe("自社アンケート_1_再来");
      expect(display_name.value).toBe("自社アンケート表示名_1_再来");
      expect(description.value).toBe("自社アンケート1_説明");

      // placeholderの確認
      expect(name.placeholder).toBe("例：男性用アンケート2");
      expect(display_name.placeholder).toBe("例：男性用アンケート");
      expect(description.placeholder).toBe("アンケート詳細を入力してください");
      

      // ボタン類
      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.getByText('更新する')).toBeInTheDocument();
      
    });  
  });
});

